class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.getPreOrderVariantData();
    this.updatePickupAvailability();
    this.updateContent();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).forEach(
      (select, index) => {
        const target = select.children?.[0]?.children?.[1];
        if (target && this.options[index] !== undefined) {
          target.innerHTML = this.options[index];
        }
      }
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData || !Array.isArray(variantData)) return;

    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    if (mediaGallery && typeof mediaGallery.setActiveMedia === "function") {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    }
  }

  updateContent() {
    let variant = this.currentVariant;
    let variandID = this.currentVariant?.id ?? null;

    // Back In Stock Notification
    let notifyMeAvailableWrapperList = document.querySelectorAll(
      `.notify__me--available-${this.dataset.section}`
    );

    if (notifyMeAvailableWrapperList.length > 0) {
      notifyMeAvailableWrapperList.forEach((notifyMeAvailableWrapper) => {
        if (variandID != null && !variant.available) {
          let soldOurtProductURL = document.querySelector(
            ".soldout__product_url"
          );
          if (soldOurtProductURL) {
            soldOurtProductURL.value = `${this.dataset.origin}${this.dataset.url}?variant=${this.currentVariant.id}`;
          }
          if (notifyMeAvailableWrapper) {
            notifyMeAvailableWrapper.classList.remove("no-js-inline");
          }
        } else {
          if (notifyMeAvailableWrapper) {
            notifyMeAvailableWrapper.classList.add("no-js-inline");
          }
        }
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    if (!this.currentVariant) return;
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    const variantData = this.getVariantData();
    if (!variantData || !Array.isArray(variantData)) return;

    const checked = this.querySelector(":checked");
    if (!checked) return;

    const selectedOptionOneVariants = variantData.filter(
      (variant) => checked.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const prevWrapper = inputWrappers[index - 1];
      const prevChecked = prevWrapper?.querySelector(":checked");
      if (!prevChecked) return;
      const previousOptionSelected = prevChecked.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const val = input.getAttribute("value");
      if (listOfAvailableOptions.includes(val)) {
        input.innerText = val;
      } else {
        const unavailableMsg = window.variantStrings?.unavailable_with_option || "[value] - Unavailable";
        input.innerText = unavailableMsg.replace(
          "[value]",
          val
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      if (typeof pickUpAvailability.fetchAvailability === "function") {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    if (!this.currentVariant) return;
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        let id = `price-${this.dataset.section}`,
          stockInventory = `inventory__stock--${this.dataset.section}`,
          barcodeId = `barcode__${this.dataset.section}`,
          skuId = `sku__${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        let destination = document.getElementById(id),
          stockInventoryDestination = document.getElementById(stockInventory),
          barcodeDestination = document.getElementById(barcodeId),
          skuDestination = document.getElementById(skuId);

        let source = html.getElementById(id),
          stockInventorySource = html.getElementById(stockInventory),
          barcodeSource = html.getElementById(barcodeId),
          skuSource = html.getElementById(skuId);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stockInventorySource && stockInventoryDestination)
          stockInventoryDestination.innerHTML = stockInventorySource.innerHTML;
        if (barcodeSource && barcodeDestination)
          barcodeDestination.innerHTML = barcodeSource.innerHTML;
        if (skuSource && skuDestination)
          skuDestination.innerHTML = skuSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("no-js-inline");

        const soldOutText = window.variantStrings?.soldOut || "Sold out";
        this.toggleAddButton(
          !this.currentVariant.available,
          soldOutText
        );
      })
      .catch((err) => {
        console.error("Error rendering product info:", err);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector(".cart--button-text") || addButton;

    const addToCartText = window.variantStrings?.addToCart || "Add to cart";
    const soldOutText = window.variantStrings?.soldOut || "Sold out";
    const preorderText = window.variantStrings?.preorder || "Pre-order";

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.innerHTML = `${addToCartText}`;
    }

    // Preorder Button
    if (window.preorder_button) {
      let productVarArray = this.PreorderVariantData;
      let variant = this.currentVariant;
      let VarInventoryManagement =
        this.currentVariant?.inventory_management ?? null;
      let var_num = "";
      if (VarInventoryManagement != null && productVarArray && variant) {
        for (let variant_id in productVarArray) {
          if (variant.id == variant_id) {
            var_num = productVarArray[variant_id].qty;
            var inventoryQuantity = parseInt(var_num, 10);
            var inventoryPolicy = productVarArray[variant_id].inventory_policy;

            if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
              addButton.removeAttribute("disabled");
              addButtonText.innerHTML = `${preorderText}`;
            } else if (inventoryQuantity <= 0 && inventoryPolicy !== "continue") {
              addButton.setAttribute("disabled", true);
              addButtonText.textContent = soldOutText;
            } else {
              addButton.removeAttribute("disabled");
              addButtonText.innerHTML = `${addToCartText}`;
            }
          }
        }
      }
    }
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector(".cart--button-text") || addButton;
    const price = document.getElementById(`price-${this.dataset.section}`);
    addButtonText.textContent = window.variantStrings?.unavailable || "Unavailable";
    addButton.setAttribute("disabled", true);
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    if (!this.variantData) {
      const el = this.querySelector("[data-variant]");
      if (el && el.textContent) {
        try {
          this.variantData = JSON.parse(el.textContent);
        } catch (e) {
          this.variantData = [];
        }
      } else {
        this.variantData = [];
      }
    }
    return this.variantData;
  }

  getPreOrderVariantData() {
    if (!this.PreorderVariantData) {
      const el = this.querySelector("[data-preorder]");
      if (el && el.textContent) {
        try {
          this.PreorderVariantData = JSON.parse(el.textContent);
        } catch (e) {
          this.PreorderVariantData = {};
        }
      } else {
        this.PreorderVariantData = {};
      }
    }
    return this.PreorderVariantData;
  }
}
if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    const variantList = this.getVariantData() || [];
    const swatchButtonList = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    if (!variantList.length || !swatchButtonList.length) return;

    const result = Object.values(
      variantList.reduce((total, item) => {
        let k = `${item[this.dataset.colorSwatch]}`;
        if (!total[k]) {
          total[k] = { ...item, count: 1 };
        } else {
          total[k].count += 1;
        }
        return total;
      }, {})
    );

    if (swatchButtonList.length > 0) {
      swatchButtonList.forEach((button) => {
        result.forEach((data) => {
          if (data[this.dataset.colorSwatch] === button.dataset.value) {
            if (
              this.dataset.colorSwatchStyle === "image" &&
              data.featured_image !== null &&
              data.featured_image?.src
            ) {
              button.setAttribute(
                "style",
                `--swatch-background-image: url(${
                  data.featured_image.src
                }); --swatch-background-color: ${
                  data[this.dataset.colorSwatch]
                };`
              );
            } else {
              button.setAttribute(
                "style",
                `--swatch-background-color: ${data[this.dataset.colorSwatch]};`
              );
            }
          }
        });
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checked = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checked ? checked.value : "";
    });
  }

  updateOptionsParent() {
    this.fieldsets.forEach((fieldset, index) => {
      const target = fieldset.children?.[0]?.children?.[1];
      if (target && this.options[index] !== undefined) {
        target.innerHTML = this.options[index];
      }
    });
  }
}
if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}
